import React from 'react';
import ProjectsSection from '../components/ProjectComponents';
import Helmet from '../components/Helmet';

export default () => (
  <main>
    <Helmet
      title="Gowtham Selvaraj (Gauti) Projects"
      description="A collection of my open-source works and recent projects"
      path="/projects"
    />
    <ProjectsSection projectPage />
  </main>
);



// WEBPACK FOOTER //
// ./src/pages/projects.js